import { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { css } from '@emotion/react';

import emitterEvents from '../../constants/emitterEvents';
import UPGRADES from './query.graphql';

const bubbleStyles = css`
  font-weight: 500;
  padding: 1px 3px;
  background-color: #d64040;
  color: white;
  display: inline-block;
  font-size: 11px;
  font-size: 0.688rem;
  border-radius: 3px;
  line-height: 1.3;
  border: 1px #fff solid;
  vertical-align: text-bottom;
`;

function RefetchListener({ refetch }) {
  useEffect(() => {
    window.emitter.on(emitterEvents.shownUpgradesChanged, refetch);

    return () => {
      window.emitter.off(emitterEvents.shownUpgradesChanged, refetch);
    };
  }, []);

  return null;
}

RefetchListener.propTypes = {
  refetch: PropTypes.func.isRequired,
};

const UpgradesBubble = ({ className, isLoggedIn }) => {
  const { data, loading, error, refetch } = useQuery(UPGRADES, { ssr: false });

  if (loading || error || !isLoggedIn) {
    return null;
  }

  const { numberOfUpgrades } = data.user;

  return (
    <Fragment>
      <RefetchListener refetch={refetch} />
      {numberOfUpgrades.length > 0 && (
        <span className={className} css={bubbleStyles}>
          {numberOfUpgrades}
        </span>
      )}
    </Fragment>
  );
};

UpgradesBubble.defaultProps = {
  className: undefined,
};

UpgradesBubble.propTypes = {
  className: PropTypes.string,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default UpgradesBubble;
